import { render } from "./BaseModalButton.vue?vue&type=template&id=54b0df05&scoped=true"
import script from "./BaseModalButton.vue?vue&type=script&lang=js"
export * from "./BaseModalButton.vue?vue&type=script&lang=js"

import "./BaseModalButton.vue?vue&type=style&index=0&id=54b0df05&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b0df05"]])

export default __exports__